export enum UserField {
  UUID = 'UUID',
  USER_TYPE = 'userType'
}
